import Axios from 'axios'

Axios.defaults.baseURL = `${process.env.VUE_APP_API}`

// request interceptor
Axios.interceptors.request.use(function (config) {
  return config
}, function (error) {
  console.log('request : ', error)
  // Do something with request error
  return Promise.reject(error)
})

// response interceptor
Axios.interceptors.response.use(function (response) {
  // Do something with response data
  return response
}, function (error) {
  console.log('response : ', error.response)
  // Do something with response error
  return Promise.reject(error)
})
